import { useFormikContext, getIn } from "formik";
import { Paper, Stack, Typography, TextField, InputAdornment, useTheme } from "@mui/material";
import { HugeiconsIcon } from "@hugeicons/react";
import { ThumbsUpIcon, Facebook01Icon, InstagramIcon, TiktokIcon } from "@hugeicons/core-free-icons";

const SocialMediaSection = () => {
  const { values, handleChange, handleBlur, touched, errors } = useFormikContext<any>();
  const theme = useTheme();

  const facebookError = getIn(errors, "organization.facebook");
  const facebookTouched = getIn(touched, "organization.facebook");
  
  const instagramError = getIn(errors, "organization.instagram");
  const instagramTouched = getIn(touched, "organization.instagram");

  const tiktokError = getIn(errors, "organization.tiktok");
  const tiktokTouched = getIn(touched, "organization.tiktok");

  return (
    <Paper sx={{ p: 3, borderRadius: 3 }}>
      <Stack spacing={3}>
        {/* Section Title with Icon */}
        <Stack direction="row" spacing={2} alignItems="center">
          <HugeiconsIcon icon={ThumbsUpIcon} size={32} color={theme.palette.primary.main} />
          <Typography variant="h3">Redes Sociales</Typography>
        </Stack>

        <Stack spacing={2}>
          {/* Facebook */}
          <TextField
            label="Facebook"
            type="url"
            name="organization.facebook"
            value={values.organization.facebook ?? ""}
            onChange={handleChange}
            onBlur={handleBlur}
            error={Boolean(facebookTouched && facebookError)}
            helperText={facebookTouched && facebookError ? facebookError : ""}
            fullWidth
            size="small"
            slotProps={{
              input: {
                startAdornment: (
                  <InputAdornment position="start">
                    <HugeiconsIcon icon={Facebook01Icon} />
                  </InputAdornment>
                ),
              },
            }}
          />

          {/* Instagram */}
          <TextField
            label="Instagram"
            type="url"
            name="organization.instagram"
            value={values.organization.instagram ?? ""}
            onChange={handleChange}
            onBlur={handleBlur}
            error={Boolean(instagramTouched && instagramError)}
            helperText={instagramTouched && instagramError ? instagramError : ""}
            fullWidth
            size="small"
            slotProps={{
              input: {
                startAdornment: (
                  <InputAdornment position="start">
                    <HugeiconsIcon icon={InstagramIcon} />
                  </InputAdornment>
                ),
              },
            }}
          />

          {/* TikTok */}
          <TextField
            label="TikTok"
            type="url"
            name="organization.tiktok"
            value={values.organization.tiktok ?? ""}
            onChange={handleChange}
            onBlur={handleBlur}
            error={Boolean(tiktokTouched && tiktokError)}
            helperText={tiktokTouched && tiktokError ? tiktokError : ""}
            fullWidth
            size="small"
            slotProps={{
              input: {
                startAdornment: (
                  <InputAdornment position="start">
                    <HugeiconsIcon icon={TiktokIcon} />
                  </InputAdornment>
                ),
              },
            }}
          />
        </Stack>
      </Stack>
    </Paper>
  );
};

export default SocialMediaSection;
